import React,{useState} from 'react';
import './Upload.css';
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from '@mui/icons-material/Close'
import { Button,Dialog,DialogActions,DialogContent,DialogTitle,Stack,Typography,TextField,FormControl,InputLabel,Select,MenuItem,FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
import axios from 'axios';
import { config } from '../App';
import { createTheme ,ThemeProvider} from '@mui/material/styles';

const theme = createTheme({
    palette:{
        textfield:{
            main:'#ffffff99'
        }
    }
    
})
const Upload = ()=>{

    const [open,setOpen] = useState(false);
    const [value, setValue] = useState(dayjs(new Date()));
    const [postData,setPostData] = useState({
        videoLink: "",
        previewImage: "",
        title: "",
        contentRating: "",
        genre: "",
        releaseDate: value,
    })

    const handleLink = (link)=>{
        let url = new URL(link);
        console.log(url)
        let param = url.searchParams.get('v');
        let formattedLink = `youtube.com/embed/${param}`;
        console.log(formattedLink);
        setPostData({...postData,videoLink:formattedLink});
    }

    const handleClickUpload = ()=>{
        setOpen(true);
    }

    const handleCancel = ()=>{
        setOpen(false);
    }

    const handleDateChange = (newDate)=>{

        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "June",
            "July",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ]

        let dateStr = newDate.get('date') + ' ' + months[newDate.get('month')] + ' ' + newDate.get('year')
        setValue(newDate)
        setPostData({ ...postData, releaseDate: dateStr });
    }

    const handlePostData = async (data)=>{
        console.log(data)
        if(data.videoLink && data.previewImage && data.title && data.genre && data.releaseDate){
            try {
                let res = await axios.post(config.endpoint+'/v1/videos',data,{
                    headers:{
                        'Content-Type':'application/json'
                    }
                })
                handleCancel();
            } catch (error) {
                console.log(error);
            }
        }
    }
    



    return (
        <div>
            <Button id="upload-btn"variant='contained'onClick={handleClickUpload}startIcon={<FileUploadIcon/>} sx={{height:'40px',marginRight:'24px',textTransform:'capitalize'}}>Upload</Button>
            <Dialog open={open} onClose={handleCancel}>
                <DialogTitle>
                    <Stack direction='row' justifyContent='space-between' >
                        <Typography variant="h6" component="h2">
                            Upload Video
                        </Typography>
                        <CloseIcon onClick={handleCancel}/>
                    </Stack>
                </DialogTitle>
                <DialogContent sx={{width:'400px'}}>
                    <Box sx={{marginTop:'28px'}}>
                        <ThemeProvider theme={theme}>
                    <TextField
                            className="video-tile-link"
                            id="videoLink"
                            placeholder='Video Link'
                            variant="outlined"
                            helperText="This link will be used to derive the video"
                            label='Video Link'
                            fullWidth
                            // color='textfield'
                            // inputProps={{ style: {color: '#ffffff99'}}}
                            // InputLabelProps={{ style: {color: '#ffffff99'}}}
                            // FormHelperTextProps={{ style: {color: '#ffffff99'}}}
                            onChange={(e) => handleLink(e.target.value)}
                        />
                    <TextField
                            className="video-tile-link"
                            id="thumbnailImageLink"
                            placeholder="Thumbnail Image Link"
                            variant="outlined"
                            helperText="This link will be used to preview the thumbnail image"
                            label='Thumbnai Image Link'
                            fullWidth
                            // color='textfield'
                            // inputProps={{ style: {color: '#ffffff99'}}}
                            // InputLabelProps={{ style: {color: '#ffffff99'}}}
                            // FormHelperTextProps={{ style: {color: '#ffffff99'}}}
                            onChange={(e) =>
                                setPostData({ ...postData, previewImage: e.target.value })
                            }
                        />
                    <TextField
                            className="video-tile-link"
                            id="title"
                            placeholder="Title"
                            variant="outlined"
                            label='Title'
                            helperText="This title will be representative text for video"
                            fullWidth
                            // color='textfield'
                            // inputProps={{ style: {color: '#ffffff99'}}}
                            // InputLabelProps={{ style: {color: '#ffffff99'}}}
                            // FormHelperTextProps={{ style: {color: '#ffffff99'}}}
                            onChange={(e) =>
                                setPostData({ ...postData, title: e.target.value })
                            }
                            
                        />
                    <FormControl fullWidth sx={{marginBottom:'17px'}}>
                            <InputLabel id="genre">Genre</InputLabel>
                            <Select
                                className="genre-btn"
                                labelId="genre"
                                id="genreFilter"
                                label="Genre"
                                value={postData.genre}
                                // SelectDisplayProps={{ style: {color: '#ffffff99'}}}
                                // inputProps={{ style: {color: '#ffffff99'}}}
                                onChange={(e) =>
                                    setPostData({ ...postData, genre: e.target.value })
                                }
                                // sx={{
                                //         color: "white",
                                //         '.MuiOutlinedInput-notchedOutline': {
                                //         borderColor: '#ffffff99',
                                //         },
                                //         '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                //         borderColor: '#ffffff99',
                                //         },
                                //         '&:hover .MuiOutlinedInput-notchedOutline': {
                                //         borderColor: '#ffffff99',
                                //         },
                                //         '.MuiSvgIcon-root ': {
                                //         fill: "#ffffff99 !important",
                                //         }
                                //     }}
                                
                            >
                                <MenuItem value={"Education"}>Education</MenuItem>
                                <MenuItem value={"Sports"}>Sports</MenuItem>
                                <MenuItem value={"Comedy"}>Comedy</MenuItem>
                                <MenuItem value={"Lifestyle"}>Lifestyle</MenuItem>
                                {/* <MenuItem value={"Movies"}>Movies</MenuItem> */}
                            </Select>
                            <FormHelperText sx={{ marginBottom: "4px"}}>
                                Genre will help in categorizing your videos
                            </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom:'17px'}}>
                            <InputLabel id="age">Suitable age group for the clip</InputLabel>
                            <Select
                                labelId="age"
                                id="ageFilter"
                                value={postData.contentRating}
                                label="Suitable age group for the clip"
                                // SelectDisplayProps={{ style: {color: '#ffffff99',background:''}}}

                                onChange={(e) =>
                                    setPostData({ ...postData, contentRating: e.target.value })
                                }
                            >
                                {/* <MenuItem value={"Anyone"}>Anyone</MenuItem> */}
                                <MenuItem value={"7+"}>7+</MenuItem>
                                <MenuItem value={"12+"}>12+</MenuItem>
                                <MenuItem value={"16+"}>16+</MenuItem>
                                <MenuItem value={"18+"}>18+</MenuItem>
                            </Select>
                            <FormHelperText sx={{ marginBottom: "4px" }}>
                                This will be used to filter videos on age group suitability
                            </FormHelperText>
                    </FormControl>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DesktopDatePicker
                                label="Upload and Publish Date"
                                inputFormat="DD/MM/YYYY"
                                value={value}
                                onChange={handleDateChange}
                                renderInput={(params) => (
                                    <TextField
                                        sx={{marginBottom:'29px'}}
                                        // FormHelperTextProps={{ style: {color: '#ffffff99'}}}
                                        {...params}
                                        helperText="This will be used to sort videos"
                                    />
                                )}
                                
                            />
                        </LocalizationProvider>
                        <Stack direction='row' justifyContent='flex-start'>
                            <Button  id="upload-btn-submit" variant='contained' onClick={()=>handlePostData(postData)} sx={{backgroundColor:'#EE1520'}}>Upload Video</Button>
                            <Button id='upload-btn-cancel' sx={{color:'black'}}onClick={handleCancel}>Cancel</Button>
                        </Stack>
                        </ThemeProvider>
                        </Box>
                </DialogContent>
                {/* <DialogActions>
                    <Stack direction='row' justifyContent='flex-start'>
                        <Button variant='contained' onClick={handleCancel}>Upload Video</Button>
                        <Button onClick={handleCancel}>Cancel</Button>
                    </Stack>
                </DialogActions> */}
             </Dialog>
        </div>
        
    )
}

export default Upload;